import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { AnimatedCard } from 'src/app/components/Elements/Animation/AnimatedCard';
import { HeadingTwo, Subtitle, SubtitleBlock } from 'src/app/components/Pages/Medications/PendingMedication/styles';

import { FLOW, MATCH_TYPE } from '../GetStarted/consts';

const ONE_DAY = 86400000;
export const ProcessingEscripts = ({ handleOpenLiveChat }) => {
  const onboardingInfo = JSON.parse(localStorage.getItem('personalizedOnboarding'));
  const currTime = Date.now();
  const timeDiff = currTime - Number(onboardingInfo?.timestamp);
  const under24Hours = timeDiff < ONE_DAY;

  // Partial matches or exact matches with escripts
  // (but no active/pending meds) are processing
  const isProcessingMatch =
    onboardingInfo?.matchType === MATCH_TYPE.FULL_ONLY_ONE_MATCH ||
    onboardingInfo?.matchType === MATCH_TYPE.PARTIAL_OR_MULTIPLE_MATCH;
  // Show processing for any matches with doctor flow and no meds
  const isEscriptLookup = onboardingInfo?.intent === FLOW.DOCTOR_ESCRIPT;

  // && noMedications
  if (under24Hours && (isEscriptLookup || isProcessingMatch)) {
    return (
      <TransitionGroup>
        <CSSTransition
          in={true}
          timeout={1500}
          classNames={{
            // Passing in null here due to the api erroring out without it.
            // We use csstransition for delaying an unmount action until the
            // unmount animation is finished. Will be cleaned up in a future pr
            // that coalesces all of our animation logic
            enter: null,
            enterActive: null,
            exit: null,
            exitActive: null,
          }}
          mountOnEnter
          unmountOnExit
        >
          <AnimatedCard variant={'condensed'}>
            <HeadingTwo data-cy="medication-name">Processing prescriptions</HeadingTwo>
            <Subtitle>
              This typically takes one hour.{' '}
              <SubtitleBlock>
                Questions?{' '}
                <a
                  href="#"
                  className={'contrast'}
                  onClick={handleOpenLiveChat}
                  data-cy="chat-link"
                  aria-label="Click here for live chat"
                >
                  Chat with a pharmacist
                </a>
              </SubtitleBlock>
            </Subtitle>
          </AnimatedCard>
        </CSSTransition>
      </TransitionGroup>
    );
  }

  return null;
};
